export const getShortcutsModalStatusSelector = (state) => state.general.isShortcutsModalOpen;
